import { observer } from "mobx-react-lite";
import React, { useContext } from "react";

import { CenteredLargeSpinner, Stack } from "@bps/fluent-ui";
import { DataFetcher } from "@ui-components/data-fetcher/DataFetcher.tsx";

import { BookingCalendarEventContext } from "../BookingCalendarEventContext.tsx";
import { GroupAppointmentAttendeeRow } from "./GroupAppointmentAttendeeRow.tsx";

export const GroupAppointmentAttendeeRows: React.FC = observer(() => {
  const { calendarEvent } = useContext(BookingCalendarEventContext);

  if (!calendarEvent.isGroupAppointment) return null;

  const maxParticipants = calendarEvent.maxParticipants ?? 0;
  const spacesRemaining =
    maxParticipants && maxParticipants - calendarEvent.activeAttendees.length;

  return (
    <DataFetcher
      fetch={({ practice }) =>
        practice.getContactsById(
          calendarEvent.activeAttendees.map(a => a.attendeeId)
        )
      }
      fallback={<CenteredLargeSpinner />}
    >
      {() => (
        <Stack tokens={{ childrenGap: 8 }}>
          <div style={{ textAlign: "right" }}>
            Spaces remaining: <strong>{spacesRemaining}</strong>
          </div>
          {calendarEvent.sortedAttendees.map(a => (
            <GroupAppointmentAttendeeRow attendee={a} key={a.attendeeId} />
          ))}
        </Stack>
      )}
    </DataFetcher>
  );
});
